import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from '../i18n/ar.json';
import en from '../i18n/en.json';
import { readPref, writePref } from './sharedPrefs';

const DEFAULT_LANG = 'ar';
const PREF = 'jawabai_lang';

// A ?lang=ar|en link (from the marketing site, or an old bookmark) is an explicit
// choice and wins; otherwise the shared cookie, then this browser's own storage.
const urlLang = new URLSearchParams(window.location.search).get('lang');
if (urlLang === 'ar' || urlLang === 'en') writePref(PREF, urlLang);
const saved = readPref(PREF);
if (saved) writePref(PREF, saved);

i18n.use(initReactI18next).init({
  resources: { ar: { translation: ar }, en: { translation: en } },
  lng: saved || DEFAULT_LANG,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

function applyDir(lng) {
  const dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
  document.documentElement.dir = dir;
}

applyDir(i18n.language);

i18n.on('languageChanged', (lng) => {
  applyDir(lng);
  writePref(PREF, lng);
});

export default i18n;
